<template>
  <div class="animated fadeIn list-of-fa">
    <b-card v-if="showList">
      <div slot="header">List of Fixed Assets 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="manageImages"><i class="fa fa-file-image-o"></i> Images</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Form - Detail Info</b-dropdown-item>
            <b-dropdown-item @click="printlabel" >Label</b-dropdown-item>
            <b-dropdown-item @click="printlabels" :disabled="(selected.length==0)">Label({{selected.length}} yg terpilih) </b-dropdown-item>
            <b-dropdown-item @click="showlabelManualFrm" >Label Manual Input </b-dropdown-item>
            <b-dropdown-item @click="showUploadFrm=true" >Label from XLSX file </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">PO # &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomorpo" placeholder="Purch. Order#"></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row>    
              <b-input-group >
                <b-input-group-prepend><label>Asset ID/Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.asetid" placeholder="(% for wildcard)" class="mr-2"></b-form-input>
                <b-input-group-prepend><span class="pt-2 mr-1">Asset Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.asdesc" placeholder="FA Name/Description" style="width:40% !important;"></b-form-input>
              </b-input-group>
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col  lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Depreciation Outstanding &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.outstand" :plain="true" :options="YesNoAll"></b-form-select>
                    </b-input-group>
                </b-col>
              </b-row>     
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>User | Location</label></b-input-group-prepend>
              <b-form-input v-model="tblData.asuser" placeholder="User"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow=true" ><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
              <b-form-input v-model="tblData.aslocat" placeholder="Location" class="ml-2"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuAssetlocatShow=true"> <i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
                      <b-form-input v-model="tblData.asserial" placeholder="Serial Number" class="ml-1"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="4" > 
                   <div style="text-align:right;margin-top:5px;">
                    <b-button variant="success" size="sm" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                   </div>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowPrintLabel(data.item)" href="#" style="padding:0 !important;">Print Label</b-dropdown-item>
        </b-dropdown>
      </template>
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-asetkey="data.item.asetkey"
            :checked="ischeckedjurnal(data.item.asetkey)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        

        <template v-slot:cell(asdatacq)="data">
          {{data.item.asdatacq| moment('D-MMM-YY')}} 
        </template>
        <!-- <template v-slot:cell(nomorpo)="data">
          <router-link :to="{ name: 'procurement.poinvpaymbyponumber', query: {ponumber: data.item.nomorpo}}" target="_blank">{{data.item.nomorpo}}</router-link>
        </template> -->
        <template v-slot:cell(aslocat)="data">
          <span v-if="(data.item.namalokasi)">{{data.item.kodelokasi}} | {{data.item.namalokasi}}</span>
          <span v-else>{{data.item.aslocat}}</span>
        </template>
        <template v-slot:cell(asuser)="data">
          <div v-if="(data.item.aspublic==-1)"> Available (Not Used) </div>
          <div v-else>
              <span v-if="(data.item.crewname)">{{data.item.crewnik}} | {{data.item.crewname}}</span>
              <span v-else>{{data.item.asuser}} {{data.item.userdepartname}}</span>
          </div>
        </template>
        <template v-slot:cell(tglgaransi)="data">
          <span v-if="(data.item.txtgaransi)">{{data.item.txtgaransi}} &nbsp;</span>
          <span v-if="(data.item.tglgaransi)">Exp.{{data.item.tglgaransi| moment('D-MMM-YY')}}</span>
        </template>

      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" ></b-form-input>  
              <!-- <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/> -->
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right" v-if="pagination"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="(showList==false)">
      <div slot="header">Fixed Asset's Images 
        <div class="card-header-actions">
          <!-- <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button> -->
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="6">
                <b-row no-gutters >
                  <b-col lg="5" >
                    <b-input-group class="pr-1">
                        <b-input-group-prepend><label>Fixed Asset</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-form-input v-model="model.asdesc" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial"  readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.catgname" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input disabled v-model="model.asdatacq" type="date"  readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
          <b-col lg="6">
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Desc./Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.txtgaransi" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tglgaransi" type="date" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="model.vendorinfo" disabled></b-form-input>                                        
                </b-input-group>
          </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" v-for="(item,index) in itemImg" :key="item.imgKey">
            <div style="text-align:center;">
              <b-card img-alt="Image" img-top>
                <img :src="itemImg[index].imgDataUrl">
                <div slot="footer">
                  <b-button variant="btn btn-primary mr-1" @click="toggleShowImg(index)"> <i class="fa fa-file-image-o"></i> Upload</b-button>
                  <b-button variant="btn btn-primary mr-1" @click="deleImage(index)"><i class="fa fa-trash"></i>
                  </b-button>
                  </div>
              </b-card>
            </div>

          <my-upload field="gambar" :noCircle="true" 
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="showImgTool"
              :width="450"
              :height="450"
              :url="imgUploadUrl"
              langType="en"
              :params="itemImg[index].imgParams"
              :headers="imgHeaders"
              img-format="png"></my-upload>
        </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="showFormLabel" size="md" :hide-footer="true" title="Nomor Fixed Asset akan cetak" :centered="true">                
                    <ul>
                        <li v-for="(nomor,idx) in arrLabel" :key="`label-${idx}`" >
                                {{nomor}} <b-link @click="delLabel(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link>
                        </li>               
                    </ul>
                    <div style="width:425px;">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-2">Tambah Nomor </span></b-input-group-prepend>
                            <b-form-input v-model="nomorlabel" class="ml-1" ></b-form-input>
                            <b-input-group-append>
                              <b-button class="btn btn-secondary ml-3" size="sm" @click="addLabel">
                                Add to list
                              </b-button>
                            </b-input-group-append>
                            <b-input-group-append>
                              <b-button class="btn btn-success ml-1" @click="printlabelManual">
                                Print
                              </b-button>
                            </b-input-group-append>

                        </b-input-group>
                    </div>
        </b-modal> 


      <b-modal v-model="showUploadFrm" header-bg-variant="primary" size="lg" title="Print Label from XLSX" :centered="true" @ok="uploadLabel" ok-title="Process">
              <b-input-group >
                  <b-input-group-prepend><label>Choose *.XLSX file</label></b-input-group-prepend>
                  <b-form-file
                    v-model="fileXlsx"
                    :state="Boolean(fileXlsx)"
                    placeholder="Choose a XLSX file..."
                    drop-placeholder="Drop XLSX file here..."
                  ></b-form-file>
              </b-input-group>
              <b-row no-gutters>
                <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend ><span class="p-2">Excel Worksheet Name </span></b-input-group-prepend>
                      <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
                  </b-input-group>
                </b-col>
                <b-col lg="3">
                      <b-input-group>
                        <b-input-group-append ><label class="input-group-text">Column Name </label></b-input-group-append>
                          <b-form-select v-model="frmUpload.columnName" :plain="true" :options="kolomXls" :state="!$v.frmUpload.columnName.$error"></b-form-select>                              
                      </b-input-group>
                </b-col>
                <b-col lg="3">
                  <b-input-group>
                      <b-input-group-append ><label class="input-group-text">Staring from Row </label></b-input-group-append>
                      <b-form-input v-model="frmUpload.startRow"  type="number" :state="!$v.frmUpload.startRow.$error"></b-form-input>
                  </b-input-group>
                </b-col>
              </b-row>
      </b-modal>

       <b-modal v-model="showDeleImgTool" title="DELETE IMAGE ?" :centered="true" @ok="deletingimage">
        <p class="mb-1 text-center" >This image will be delete</p>
        <p class="font-weight-bold mb-1" style="text-align:center;">Are you sure?</p>
      </b-modal>

        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuAssetlocatShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-assetlocat @click="onSelectLkuAssetlocat"></lku-assetlocat>
        </b-modal>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-fa {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
  .input-group {
      .input-group-prepend {
          label {
              width: 110px !important;
          }
      }
  }  
 
}
</style>

<script>
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";

import lkuCrew from "../lookup/lkuCrewFull";
import lkuAssetlocat from "../lookup/lkuAssetlocat";
import fixedasset from "../../apis/fixedasset";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  components: { Loading,lkuCrew, lkuAssetlocat, myUpload},
  mixins: [validationMixin],
  validations: {
        frmUpload: {
            sheetName: { required },
            columnName: { required },
            startRow: { required }
        },
  }, 

  data() {
    return {
      limit:15,
      showFormLabel: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      arrLabel:[],
      nomorlabel:'',
      itemImg:[{imgDataUrl:'', imgKey:'0'},{imgDataUrl:'', imgKey:'1'},{imgDataUrl:'', imgKey:'2'},{imgDataUrl:'', imgKey:'3'}],
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      img3:'',
      imgIndex:0,
      showImgTool:false,
      showDeleImgTool:false,
      lkuCrewData:{},
      lkuCrewShow:false,
      lkuAssetlocatShow:false,
      showDelConfirm: false,
      showList:true,
      showForm:false,
      showFilter:false,
      pagination:false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        tgl1:'',
        tgl2:'',
        sortBy: 'asdatacq',
        sortDesc: true,outstand: ''
      },
      model:{asetkey:''},
      YesNoAll: dropdown.YesNoAll,
      selected:[],selectedid:[],
      categories:[],
      printerReady:false,
      print2default: false,
      printers: [],
      selected_printer: '',

      showUploadFrm: false,
      fileXlsx: null,
      frmUpload:{sheetName:'Sheet1', startRow:5, columnName:'A'},
      kolomXls:['','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z',
      'AA','AB','AC','AD','AE','AF','AG','AH','AI','AJ','AK','AL','AM','AN','AO','AP','AQ','AR','AS','AT','AU','AV','AW','AX','AY','AZ'],

    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "asetid",
            label: "FA Number",
            sortable: true
          },
          {
            key: "asdesc",
            label: "FA Name/Description",
            sortable: true
          },
          {
            key: "brand",
            label: "Brand",
            sortable: true
          },
          {
            key: "asmodel",
            label: "Model/Series",
            sortable: true
          },
          {
            key: "asserial",
            label: "Serial Number",
            sortable: true
          },
          {
            key: "asdatacq",
            thStyle: "width:80px",
            label: "Acquisition Date",
            sortable: true
          },
          {
            key: "quantity",
            label: "QTY",
            sortable: true
          },
          {
            key: "nomorpo",
            label: "Reference Doc.",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "catgname",
            label: "Category/Group",
            sortable: true
          },
          {
            key: "aslocat",
            label: "Location",
            sortable: true
          },
          {
            key: "asuser",
            label: "User",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },    
    catgid() {
      return this.tblData.catgid;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    catgid: function(newval){
      const catg = this.categories.find(c => c.value == newval)
      if (catg)
      {
        this.tblData.category=catg.text;
      }
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }
  },
  created: async function(){
      const [a] = await Promise.all([fixedasset.category()]) ;
        this.categories = a.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
      // this.adjustGroups = b;
  },  
  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
    },
    checkedjurnal(item, record) {
      this.rowClicked(record);
      const asetkey = item.target.attributes["data-asetkey"].value;
      // const asetid = item.target.attributes["data-asetid"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === asetkey);
        if (!(findjv)){
          this.selected.push(asetkey);
          // this.selectedid.push(asetid);
          this.selectedid.push({asetid:record.asetid, childs: record.childs })
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === asetkey);
        this.selected.splice(findIdx, 1);
        this.selectedid.splice(findIdx, 1);
      }
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.assetList) {
            this.tblData[key] = filter.assetList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.assetList.tgl1 || '';
          this.tblData.tgl2=filter.assetList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.assetList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

                try {
                  const list = await fixedasset.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

                try {
                  const list = await fixedasset.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.catgid= '';
        this.tblData.asetid=  '';
        this.tblData.asdesc=  '';
        this.tblData.asmodel=  '';
        this.tblData.asserial=  '';
        this.tblData.nomorpo=  '';
        this.tblData.asuser=  '';
        this.tblData.aslocat=  '';
        this.tblData.outstand=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','catgid', 'category', 'catgname', 'nomorpo', 'outstand', 'asetid', 'asdesc', 'asmodel','asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
      let filtered = false;
      const assetList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              assetList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          assetList.page=this.tblData.page;
          assetList.limit=this.tblData.limit;
          assetList.sortBy=this.tblData.sortBy;
          assetList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.assetList=assetList;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintlabel(record) {
      this.rowClicked(record);
        this.printlabel();        
    },
    edit: function() {
      if (this.model.asetkey) {
        this.saveFilter();
        router.push({name :'fixedasset.formga', params: { asetkey: this.model.asetkey}});
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
             await  fixedasset.save(this.frmdata);
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    print: async function()
    {
      if (this.model) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await fixedasset.print(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printselected: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await fixedasset.printbills(this.selected);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    printlabel: async function()
    {
      if (this.model) {
          try {
              var printWindow = window.open();
              printWindow.document.open('text/plain')

              // let zpl =  "^XA";
              // zpl += "^FO48,56^BQN,2,3^FDQA,"+ this.model.asetid +"^FS";
              // zpl += "^FO140,80^ADN,15,12^FD"+ this.model.asetid +"^FS";
              //  zpl += "^XZ";
              // printWindow.document.write(zpl);
              const fa = this.model;
              let cmds='' ;
              let childs;
              if (fa.childs) {
                childs=fa.childs.split(',');
                childs.forEach(childasetid => {
                  cmds +=  "^XA";
                  cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid+"-"+childasetid +"^FS";
                  cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
                  cmds += "^FO140,120^ADN,15,12^FDC  -"+childasetid +"^FS";
                });
              }
              cmds +=  "^XA";
              cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid +"^FS";
              cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
              cmds += "^XZ";
              printWindow.document.write(cmds);

              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();
          } catch (error) {
            console.log(error);
            if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printlabels: async function()
    {
        if (this.selected) {
          try {
              let cmds="" ;
              let childs;
              var printWindow = window.open();
              printWindow.document.open('text/plain')
            this.selectedid.forEach(fa =>{
              if (fa.childs) {
                childs=fa.childs.split(',');
                childs.forEach(childasetid => {
                  cmds +=  "^XA";
                  cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid+"-"+childasetid +"^FS";
                  cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
                  cmds += "^FO140,120^ADN,15,12^FDC  -"+childasetid +"^FS";
                });
              }
              cmds +=  "^XA";
              cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid +"^FS";
              cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
              cmds += "^XZ";
            });
              printWindow.document.write(cmds);
              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();
          } catch (error) {
            console.log(error);
            if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    showlabelManualFrm: function(){
        this.showFormLabel=true;
    },
    printlabelManual: function(){
        if (this.arrLabel) {
          try {
              let cmds="" ;
              var printWindow = window.open();
              printWindow.document.open('text/plain')
            // this.arrLabel.forEach(fa =>{
            //   cmds +=  "^XA";
            //   cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa +"^FS";
            //   cmds += "^FO140,80^ADN,15,12^FD"+ fa +"^FS";
            //   cmds += "^XZ";
            //   printWindow.document.write(cmds);
            //   printWindow.document.close();
            //   printWindow.focus();
            //   printWindow.print();
            //   printWindow.close();
            // });
              for (let index = 0; index < this.arrLabel.length; index++) {
                const fa = this.arrLabel[index];
                  cmds +=  "^XA";
                  cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa +"^FS";
                  cmds += "^FO140,80^ADN,15,12^FD"+ fa +"^FS";
                  cmds += "^XZ";
              }
              printWindow.document.write(cmds);
              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();

          } catch (error) {
            console.log(error);
            if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please Input Label that want to be Printed!');
        }

    },
    addLabel : function () {
        if (this.nomorlabel) {
            const ada =this.arrLabel.find(nomor =>nomor == this.nomorlabel);
            if (ada){
                // toastr.error(`Nomor Label "${this.nomorlabel}" sudah ada dalam List`)
                this.$bvModal.msgBoxConfirm(`Nomor Label "${this.nomorlabel}" sudah ada dalam List`, {
                    title: 'Apakah tetap akan ditambahkan',
                    size: 'md',buttonSize: 'sm',okVariant: 'danger',
                    okTitle: 'YES',cancelTitle: 'NO',footerClass: 'p-2',hideHeaderClose: false,centered: true
                  }).then(value => {
                      if (value==true) {
                        this.arrLabel.push(this.nomorlabel);
                        this.$forceUpdate();
                      }              
                    })
                    .catch(err => {
                      toastr.error(err);
                    });
            } else {
                this.arrLabel.push(this.nomorlabel);
            }
        } else {
                toastr.error(`Nomor Label belum diisi`)
        }
    },
    delLabel : function (index) {
        if (index > -1) {
            this.arrLabel.splice(index, 1);
        }
        this.model.nomorlabel= this.arrLabel.join(",");
    },
    uploadLabel: async function() {
      if (this.invalidFrmUpload) {
            console.log('validation : ', this.$v.frmUpload);
            console.log('frmUpload obj : ',this.frmUpload);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.showUploadFrm = false;
            // this.isLoading=true;
            try {
                 const data = await fixedasset.uploadlabel(this.fileXlsx,this.frmUpload);
                console.log('upload result: ', data);
                toastr.info(`Printing ${data.length} lables`,'Print Label from Xlsx file',10000);
                this.arrLabel = data;
                // this.isLoading=false;   
                this.printlabelManual();
              } catch (error) {
                // this.isLoading=false;
                this.showUploadFrm = true;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else {
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }
                }
            }
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.expMode='ga';
              const response = await fixedasset.exportxls(this.tblData);
              const link = document.createElement('a');
                link.setAttribute('download', 'Fixed_asset_list.xlsx');
              const url = window.URL.createObjectURL(new Blob([response.data]));
              link.href = url;
              document.body.appendChild(link);
              link.click();
              this.isLoading=false;    
          } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
          }
    },    
    onSelectLkuCrew: function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        // this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + _selected.crewname.trim();
        this.tblData.asuser = lkuData.selected.crewname.trim();
        // this.model.crewkey = lkuData.selected.crewkey;
        // this.model.crewnik = this.model.crewnik;
        // this.model.jabatan = lkuData.selected.jabatan;
        // this.model.departemen = this.model.departemen;
        this.lkuCrewShow=false;
    },
    onSelectLkuAssetlocat: async function (_selected) {
        // this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        this.tblData.aslocat = _selected.namalokasi.trim();
        // this.model.aslocatkey = _selected.aslocatkey;
        // this.model.kodelokasi = this.model.kodelokasi;
        // this.model.namalokasi = _selected.namalokasi;
        this.lkuAssetlocatShow=false;
    },
    getImages: async function() {
      const imgOnSvr = await fixedasset.images(this.model);
          for (let index = 0; index < 4; index++) {
            this.itemImg[index].imgKey=index;
            this.itemImg[index].imgDataUrl=''
            this.itemImg[index].imgParams= {asetkey:this.model.asetkey,imgKey:index };
            if (index<imgOnSvr.length) {
              this.itemImg[index].imgKey=imgOnSvr[index].imgKey;
              this.itemImg[index].imgDataUrl=imgOnSvr[index].imgBase64;
              this.itemImg[index].imgParams.imgKey=imgOnSvr[index].imgKey;
              // dibawah ini cara lain menampilkan gambar dari server tanpa di konversi ke base64            
              // this.itemImg[index].src=`${data.baseURL}/image/asset/${imgOnSvr[index].imgKey}`;
              // in HTML Template do like this: <img :src="itemImg[index].src">
            }
          }
    },
    manageImages: async function() {
      if (this.model.asetkey) {
          this.showList=false;
          const data = await fixedasset.token();
          this.imgHeaders= data.headers;
          this.imgUploadUrl= `${data.baseURL}/fixedasset/uploadImage`;
          this.imgParams= {asetkey:this.model.asetkey};
          this.getImages();
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleImage : async function(index) {
      this.imgIndex=index;
      this.showDeleImgTool = !this.showDeleImgTool;
    },

    deletingimage: async function() {
      try {
        this.isLoading=true;
        const imgdt = this.itemImg[this.imgIndex];
        this.imgUploadUrl='';
        await fixedasset.deleteimage(imgdt.imgParams);
        this.getImages();
        this.isLoading=false;
        toastr.success('Image has been deleted');
      } catch (error) {
                this.isLoading=false;

        toastr.warn(error);
      }
    },
    toggleShowImg(index) {
        this.imgIndex=index;
          this.showImgTool = !this.showImgTool;
    },
    cropSuccess(imgDataUrl, field){
        console.log('-------- crop success --------', field);
        this.itemImg[this.imgIndex].imgDataUrl = imgDataUrl;
        // console.log(imgDataUrl);
        // console.log('content ',this[field]);
    },
    cropUploadSuccess(jsonData, field){
        console.log('-------- upload success --------');
        console.log(jsonData);
        console.log('field: ' + field);
    },
    cropUploadFail(status, field){
        console.log('-------- upload fail --------');
        console.log(status);
        console.log('field: ' + field);
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
